import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Images/pp-1.jpg";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";

import {
  slideInRight,
  bounceIn,
  slideInLeft,
  slideInUp,
  slideInDown,
} from "react-animations";
import Radium, { StyleRoot } from "radium";

function Home() {
  const styles = {
    slideInLeft: {
      animation: "x 3s",
      animationName: Radium.keyframes(slideInLeft, "bounce"),
    },
    slideInUp: {
      animation: "x 3s",
      animationName: Radium.keyframes(slideInUp, "bounce"),
    },
    slideInRight: {
      animation: "x 3s",
      animationName: Radium.keyframes(slideInRight, "bounce"),
    },
    bounceIn: {
      animation: "x 3s",
      animationName: Radium.keyframes(bounceIn, "bounce"),
    },
    slideInDown: {
      animation: "x 3s",
      animationName: Radium.keyframes(slideInDown, "bounce"),
    },
  };
  return (
    <StyleRoot>

      <section>
        <Container fluid className="home-section" id="home">
          <Particle />
          <Container className="home-content">
            <Row>
              <Col md={7} className="home-header" >
                <div style={styles.slideInDown}>
                  <h1 style={{ paddingBottom: 15 }} className="heading">
                    Hi There! {/* <span className="wave" role="img" aria-labelledby="wave">👋🏻</span> */}
                  </h1>
                </div>

                <h1 className="heading-name" style={styles.slideInRight}>
                  I'M
                  <strong className="main-name"  > Najmul Hasan</strong>
                </h1>

                <div style={{ padding: 50, textAlign: "left" }}>
                  <div style={styles.bounceIn}>
                    <Type />
                  </div>
                </div>
              </Col>

              <Col md={5} style={{ paddingBottom: 20 }}>
                <div style={styles.slideInLeft}> <img style={{ height: '420px', width: '420px', }} src={homeLogo} alt="home pic" className="img-fluid rounded-circle" />
                </div>
              </Col>
            </Row>
          </Container>
        </Container>
        <Home2 />
      </section>
    </StyleRoot>

  );
}

export default Home;
